import { Outlet } from 'react-router';

import { useMedia } from '@/shared/hooks';

import { ConfirmModal } from '@/entities/modal';
import { ReportLayout } from '@/entities/reports';

import { AddConditionModal } from '@/widgets/AddConditionModal';
import { Header } from '@/widgets/Header';

export const Report2DLayout = () => {
  const { isMobile } = useMedia();

  // For mobile layout, MobileLayout is used inside IOXRayReport component
  // Here we just return Outlet to avoid double Layout
  if (isMobile) {
    return (
      <>
        <Outlet />
        <ConfirmModal />
        <AddConditionModal />
      </>
    );
  }

  return (
    <ReportLayout.Container>
      <Header fullWidth />
      <ReportLayout.Main>
        <Outlet />
      </ReportLayout.Main>
      <ConfirmModal />
      <AddConditionModal />
    </ReportLayout.Container>
  );
};
